import React from 'react'
import { InputGroup, FormControl, Button } from 'react-bootstrap'
import { Search, X } from 'react-bootstrap-icons'

const SearchFilter = ({
    title,
    value = '',
    onChange = () => {},
    disabled,
    size
}) => {
    const iconSize = size === 'lg' ? 18 : 12
    return (
        <InputGroup className="mb-3">
            <FormControl placeholder={title} value={value || ''} onChange={e => onChange(e.target.value)}  disabled={disabled} size={size} />
            <InputGroup.Append>
                {!value && <Button variant="primary" disabled={disabled}><Search size={iconSize} /></Button>}
                {Boolean(value) && <Button variant="success" disabled={disabled} onClick={() => onChange('')}><X size={iconSize} /></Button>}
            </InputGroup.Append>
        </InputGroup>
    )
}

export default SearchFilter